import React from "react";
import styled from "@emotion/styled";
import { Button } from "react-bootstrap";
import { mediaUrl } from "./mediaUrl";
import { getQualityShortLabel } from "./qualityOptions";

const PRIMARY = "#429853";
const PRIMARY_SOFT = "#eaf4ec";
const LINE = "#e4e4e1";

const SuggestionCard = ({ suggestion, onEdit, onDelete, onDuplicate }) => {
  const img = mediaUrl(suggestion.media);
  const ingredients = suggestion.ingredients || [];
  const hasDispo = suggestion.disponibilities && suggestion.disponibilities.length;
  const dispo = hasDispo
    ? suggestion.disponibilities.map((d) => `${d.startDate} → ${d.endDate}`).join(", ")
    : "Non disponible (aucune période)";

  return (
    <Card>
      <Top>
        <Thumb>{img ? <img src={img} alt="" /> : <span>🥗</span>}</Thumb>
        <div>
          <Name>{suggestion.name}</Name>
          <Meta>
            {ingredients.length} ingrédient{ingredients.length > 1 ? "s" : ""}
            {suggestion.forcedBigBox ? " · grande boîte" : ""}
          </Meta>
        </div>
      </Top>

      <Chips>
        {ingredients.map((i) => {
          const doseLabel = i.isSauce ? getQualityShortLabel(i.quality || "normal") : null;
          return (
            <Chip key={i.id || i.compositionProductId} sauce={i.isSauce ? 1 : 0}>
              <b>×{i.quantity}</b> {i.name}
              {doseLabel && <Dose>{doseLabel}</Dose>}
            </Chip>
          );
        })}
      </Chips>

      <Dispo>
        📅 <b style={hasDispo ? undefined : { color: "#b23b3b" }}>{dispo}</b>
      </Dispo>

      <Foot>
        <Toggles>
          <Toggle>
            <Dot on={suggestion.activeOnSpot ? 1 : 0} /> Charrettes
          </Toggle>
          <Toggle>
            <Dot on={suggestion.activeOnShop ? 1 : 0} /> Boutique
          </Toggle>
        </Toggles>
        <Actions>
          <Button size="sm" variant="light" onClick={onEdit}>
            ✎ Modifier
          </Button>{" "}
          <Button size="sm" variant="outline-secondary" onClick={onDuplicate} title="Dupliquer vers d'autres établissements">
            ⧉ Dupliquer
          </Button>{" "}
          <Button size="sm" variant="outline-danger" onClick={onDelete}>
            🗑
          </Button>
        </Actions>
      </Foot>
    </Card>
  );
};

const Card = styled.div`
  background: #fff;
  border: 1px solid ${LINE};
  border-radius: 10px;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
const Top = styled.div`
  display: flex;
  gap: 12px;
  padding: 14px;
`;
const Thumb = styled.div`
  width: 62px;
  height: 62px;
  border-radius: 8px;
  background: ${PRIMARY_SOFT};
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
const Name = styled.p`
  font-weight: 800;
  font-size: 15px;
  margin: 0 0 4px;
  color: #1d1d1b;
`;
const Meta = styled.span`
  font-size: 12px;
  color: #6b6b68;
`;
const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0 14px 12px;
`;
const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: ${(p) => (p.sauce ? "#fff6e9" : "#f2f2ef")};
  border: 1px solid ${(p) => (p.sauce ? "#f1e0c4" : LINE)};
  border-radius: 20px;
  padding: 3px 9px;
  font-size: 12px;
  b {
    color: ${PRIMARY};
    font-weight: 800;
  }
`;
const Dose = styled.span`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: #9a6b2e;
  background: #fff;
  border: 1px solid #f1e0c4;
  border-radius: 10px;
  padding: 1px 5px;
  line-height: 1.3;
`;
const Dispo = styled.div`
  font-size: 11px;
  color: #6b6b68;
  padding: 0 14px 12px;
  b {
    color: #1d1d1b;
  }
`;
const Foot = styled.div`
  margin-top: auto;
  border-top: 1px solid ${LINE};
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: #fcfcfb;
`;
const Toggles = styled.div`
  display: flex;
  gap: 14px;
`;
const Toggle = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #6b6b68;
`;
const Dot = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  display: inline-block;
  background: ${(p) => (p.on ? PRIMARY : "#cfcfca")};
`;
const Actions = styled.div`
  white-space: nowrap;
`;

export default SuggestionCard;
